export const GenericEvent = {
  Name: {
    // Interview Prep Events
    startMockInterview: "startMockInterview",
    endMockInterview: "endMockInterview",
    mockInterviewComplete: "mockInterviewComplete",
    fetchReportError: "fetchReportError",
    landOnHubPage: "landOnHubPage",
    landOnHubPageWithGlassdoorBrand: "landOnHubPageWithGlassdoorBrand",
    showOccupationPicker: "showOccupationPicker",
    pickedOccupation: "pickedOccupation",
    showHistory: "showHistory",
    archiveInterview: "archiveInterview",
    // Support Events
    feedbackSubmitted: "feedbackSubmitted",
    interviewPrepPromoShown: "interviewPrepPromoShown",
    interviewPrepPromoButtonPressed: "interviewPrepPromoButtonPressed",
    resumeImprovementsCTAShown: "resumeImprovementsCTAShown",
    resumeImprovementsCTAButtonPressed: "resumeImprovementsCTAButtonPressed",
    resumeImprovementsReviewShown: "resumeImprovementsReviewShown",
    flashFeedbackShown: "flashFeedbackShown",
    flashFeedbackSubmitted: "flashFeedbackSubmitted",
    generatingReportShown: "generatingReportShown",
    summaryPageShown: "summaryPageShown",
    expandableQuestionFeedbackSeen: "expandableQuestionFeedbackSeen",
    expandableQuestionFeedbackClicked: "expandableQuestionFeedbackClicked",
    retryStartMockInterview: "retryStartMockInterview",
    onboardingContinuePressed: "onboardingContinuePressed",
    onboardingClosePressed: "onboardingClosePressed",
    preferencesStartPressed: "preferencesStartPressed",
    preferencesContinuePressed: "preferencesContinuePressed",
    introductionStartPressed: "introductionStartPressed",
    answerModalSkipPressed: "answerModalSkipPressed",
    answerModalSubmitPressed: "answerModalSubmitPressed",
    answerInputSkipPressed: "answerInputSkipPressed",
    answerInputSubmitPressed: "answerInputSubmitPressed",
    showAnswerModalPressed: "showAnswerModalPressed",
    closeAnswerModalPressed: "closeAnswerModalPressed",
    answerModalShown: "answerModalShown",
    answerAudioPlayed: "answerAudioPlayed",
    generatingStaticQuestionsShown: "generatingStaticQuestionsShown",
    generatingPersonalizedQuestionsShown: "generatingPersonalizedQuestionsShown",
    countdownShown: "countdownShown",
    textInterviewInProgressShown: "textInterviewInProgressShown",
    textInterviewStartMessageSent: "textInterviewStartMessageSent",
    textInterviewOutroReceived: "textInterviewOutroReceived",
    textInterviewChatMessageReceived: "textInterviewChatMessageReceived",
    textInterviewSkipMessageSent: "textInterviewSkipMessageSent",
    textInterviewAnswerMessageSent: "textInterviewAnswerMessageSent",
    tiWSErrorWhileStillConnecting: "tiWSErrorWhileStillConnecting",
    textInterviewWSInterviewError: "textInterviewWSInterviewError",
    tiWSConnectedAfterTimeout: "tiWSConnectedAfterTimeout",
    textInterviewWSConnected: "textInterviewWSConnected",
    textInterviewWSClosedUnexpectedly: "textInterviewWSClosedUnexpectedly",
    textInterviewWSClosedNormally: "textInterviewWSClosedNormally",
    textInterviewStartGeneratingReport: "textInterviewStartGeneratingReport",
    textInterviewLeave: "textInterviewLeave",
    messageShown: "messageShown",
    flashcardSessionStarted: "flashcardSessionStarted",
    flashcardAnswerSubmitted: "flashcardAnswerSubmitted",
    flashcardHintTapped: "flashcardHintTapped",
    flashcardHintBackToQuestionTapped: "flashcardHintBackToQuestionTapped",
    flashcardQuestionSaveChanged: "flashcardQuestionSaveChanged",
    flashcardSessionFinished: "flashcardSessionFinished",
    flashcardSessionExited: "flashcardSessionExited",
    flashcardQuestionStatsLoaded: "flashcardQuestionStatsLoaded",
    interviewAppBackgrounded: "interviewAppBackgrounded",
    interviewAppForegrounded: "interviewAppForegrounded",
    pauseInterview: "pauseInterview",
    resumeInterview: "resumeInterview",
    pauseInterviewTimedOut: "pauseInterviewTimedOut",
    startMockInterviewByPauseTimedOut: "startMockInterviewByPauseTimedOut",
    endMockInterviewByPauseTimedOut: "endMockInterviewByPauseTimedOut",
    pauseTimedOutWarningShown: "pauseTimedOutWarningShown",
  },
  Parameter: {
    // Interview Prep Params
    jobKey: "jobKey",
    jobTitle: "jobTitle",
    jobOccupationSUID: "jobOccupationSUID",
    interviewId: "interviewId",
    extractionId: "extractionId",
    intPrepSessionId: "intPrepSessionId",
    numberOfQuestions: "numberOfQuestions",
    interviewTimeInSeconds: "interviewTimeInSeconds",
    reportGenerationTimeInSeconds: "reportGenerationTimeInSeconds",
    renderError: "renderError",
    source: "source",
    difficulty: "difficulty",
    careerStage: "careerStage",
    inputType: "inputType",
    // Support Params
    supportContext: "supportContext",
    issueType: "issueType",
    feedbackType: "feedbackType",
    feedbackText: "feedbackText",
    feedbackScore: "feedbackScore",
    feedbackPrompt: "feedbackPrompt",
    feedbackPromptDetails: "feedbackPromptDetails",
    feedbackSelection: "feedbackSelection",
    feedbackSelectionIdx: "feedbackSelectionIdx",
    questionId: "questionId",
    questionIndex: "questionIndex",
    // Flash feedback
    flashFeedbackScore: "flashFeedbackScore",
    fromScreenName: "fromScreenName",
    // Flashcards
    flashcardCategory: "flashcardCategory",
    flashcardsTotalCount: "flashcardsTotalCount",
    flashcardsAnsweredCount: "flashcardsAnsweredCount",
    flashcardsSkippedCount: "flashcardsSkippedCount",
    flashcardSessionSeconds: "flashcardSessionSeconds",
    flashcardSaveAction: "flashcardSaveAction",
    flashcardAnswerInputMethod: "flashcardAnswerInputMethod",
    // Glassdoor question
    hasGlassdoorQuestions: "hasGlassdoorQuestions",
    // Paused interview
    resumeTrigger: "resumeTrigger",
    pauseDurationInSeconds: "pauseDurationInSeconds",
  },
  Tags: {
    interviewPrep: "interviewPrep",
    viewjob: "viewjob",
  },
} as const;

export type GenericEventName = (typeof GenericEvent.Name)[keyof typeof GenericEvent.Name];
export type GenericEventParameter =
  (typeof GenericEvent.Parameter)[keyof typeof GenericEvent.Parameter];
export type GenericEventTag = (typeof GenericEvent.Tags)[keyof typeof GenericEvent.Tags];

export type GenericEventParams = Partial<Record<GenericEventParameter, string | number | boolean>>;
